<template>
  <div class="coming-soon">
    <div class="coming-soon__loading-wrapper">
      <img class="coming-soon__loading" alt="loading..." src="@/assets/loading.gif" />
    </div>
    <div class="coming-soon__text-wrapper">
      <span class="coming-soon__text">Скоро тут будет что-то интересное!</span>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@import '~@/assets/styles/variables.scss';

.coming-soon {
  width: 100%;
  height: 100vh;
  @supports (height: 100dvh) {
    height: 100dvh;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;

  &__loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100px;
    max-height: 100px;

    @media (min-width: $extra-small-devices-min-width) {
      max-width: 150px;
      max-height: 150px;
    }

    @media (min-width: $large-tablets-min-width) {
      max-width: 200px;
      max-height: 200px;
    }
  }

  &__loading {
    object-fit: contain;
    object-position: center center;
    width: 100%;
    height: 100%;
  }

  &__text-wrapper {
    border-radius: 26px;
    padding: 8px 12px;
    background-color: $yellow-1;

    @media (min-width: $extra-small-devices-min-width) {
      border-radius: 31px;
      padding: 12px 18px;
    }

    @media (min-width: $large-tablets-min-width) {
      border-radius: 51px;
      padding: 16px 24px;
    }
  }

  &__text {
    font-size: 1.2rem;
    color: $black-1;
    font-weight: 600;

    @media (min-width: $extra-small-devices-min-width) {
      font-size: 1.5rem;
    }

    @media (min-width: $large-tablets-min-width) {
      font-size: 2rem;
    }
  }
}
</style>
